import type { Theme } from '@mui/material';

export const styles = {
  googleLogin: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '2.5rem',
    alignItems: 'center',
  },
  errorMsg: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
};
